function extractFileInfoFromRequest(request) {
  const { blob } = JSON.parse(request.requestBody);
  const { filename, checksum } = blob;
  const contentType = blob.content_type;
  const byteSize = blob.byte_size;

  return { filename, contentType, byteSize, checksum };
}

function s3PayloadForRequest(server, request) {
  const { filename, contentType, byteSize, checksum } = extractFileInfoFromRequest(request);
  const record = server.create('direct-upload', {
    filename,
    content_type: contentType,
    byte_size: byteSize,
    checksum,
  });

  return record.toJSON();
}

export default s3PayloadForRequest;
